import { useToi } from '../../../lib/auth.js';
import { CanhBaoDuLieuThat, HopXacNhan } from '../../../ui/index.js';

/**
 * Hộp thoại xác nhận lưu trữ kênh.
 *
 * Tách khỏi `TrangChiTietKenh` để test được bằng `react-dom/server`: hộp thoại
 * trong trang chỉ hiện sau khi bấm, mà render phía máy chủ không bấm được.
 *
 * Ở `YOUTUBE_MODE=live` hiện thêm cảnh báo đỏ: lưu trữ dừng job và thu hồi
 * token của **kênh thật**.
 */
export interface HopLuuTruKenhProps {
  tenKenh: string;
  dangChay: boolean;
  loi: string | null;
  onDong: () => void;
  onXacNhan: () => void;
}

export function HopLuuTruKenh({ tenKenh, dangChay, loi, onDong, onXacNhan }: HopLuuTruKenhProps) {
  const toi = useToi();

  return (
    <HopXacNhan
      title={`Lưu trữ kênh ${tenKenh}?`}
      nhanXacNhan="Lưu trữ kênh"
      dangChay={dangChay}
      loi={loi}
      onDong={onDong}
      onXacNhan={onXacNhan}
    >
      <CanhBaoDuLieuThat youtubeMode={toi.data?.youtubeMode} />

      <p>Kênh sẽ biến khỏi mọi danh sách, tổng kết, Tổng quan và Doanh thu kỳ mới.</p>
      <p>
        Job đồng bộ dừng lại, <strong>token Google bị thu hồi</strong>, và các bài lịch đăng{' '}
        <strong>chưa upload</strong> bị huỷ. Bài đã lên YouTube giữ nguyên.
      </p>
      <p>Số liệu, doanh thu, sao kê và lịch sử vẫn giữ. Khôi phục lại được bất cứ lúc nào.</p>
    </HopXacNhan>
  );
}
